import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jkddc7grcu: FaireBrandEntity = {
  token: "b_jkddc7grcu",
  type: "brand",
  name: "rocky's matcha",
  avatarUrl: "https://cdn.faire.com/fastly/8d59a75f9bb96d6e76e9716a5e148823f4124e02da34f22cf3a2f3a013847dfb.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/24274b7b473292dc6e1bd3a0632285770b6cf2301fd235c8a76f7d8d60556b5d.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/8d59a75f9bb96d6e76e9716a5e148823f4124e02da34f22cf3a2f3a013847dfb.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/24274b7b473292dc6e1bd3a0632285770b6cf2301fd235c8a76f7d8d60556b5d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 144,
  rating: 4.9,
  reviewCount: 16,
  isInsider: true,
  description: "Rocky’s Matcha aims to make a great cup of matcha for good people everywhere. Founded by Rocky Xu in 2022, the traveling tea house has popped up in Los Angeles, Miami, New York, and Tokyo.\n",
  meta: {
    source: "api",
    importedAt: "2026-09-07T18:42:46.876Z",
    importedBy: "entity-db-cli"
  }
};
